export default class Translation {
  constructor({ translation = {}, defaultTranslation = {} }) {
    this.translation = translation;
    this.defaultTranslation = defaultTranslation;
  }

  key(key) {
    return this.translation[key] || this.defaultTranslation[key];
  }
}
